import { serviceOperationApi } from "./api";

export async function fetchStateData({ accessToken, countryId }) {
  const res = await serviceOperationApi.get("/StateData", {
    params: { country_id: countryId },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}
